import React from 'react';
import { object } from 'prop-types';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { Icon } from '@fiverr-private/fit';
import { s_pencil } from '@fiverr-private/fit/icons';

import './style.scss';

const EditGig = (props, { pathfinderWrapper }) => {
    const { pathParameters } = getContext();
    const { username, slug } = pathParameters;
    const editGigLink = pathfinderWrapper.pathfinder('edit_user_manage_gig',
        {
            user_id: username,
            id: slug
        });

    return (
        <a href={editGigLink} className="edit-gig">
            <Icon size={14} className="edit-pencil-icon">{s_pencil}</Icon>
            <I18n k={'gig_page_perseus.top_nav.edit_gig'}/>
        </a>
    );
};

EditGig.contextTypes = {
    pathfinderWrapper: object
};

export default EditGig;
